import { Bounds } from "@/shared/types/data";
import { RefObject, useLayoutEffect, useState } from "react";

export const useBounds = (ref: RefObject<HTMLElement | null>) => {
  const [bounds, setBounds] = useState<Bounds>();

  useLayoutEffect(() => {
    if (!ref) return;

    const update = () => {
      const root = ref.current;
      if (!root) return;

      const rect = root.getBoundingClientRect();

      setBounds({
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
      });
    };

    update();

    const resizeObserver = new ResizeObserver(update);

    if (ref.current) resizeObserver.observe(ref.current);

    window.addEventListener("resize", update);

    const interval = window.setInterval(update, 250);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", update);
      window.clearInterval(interval);
    };
  }, [ref]);

  return bounds;
};
